import React from "react"; 
import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import logo from "../../../assets/Images/PickaaGoLogo.png"; // ✅ Logo import
import { SingleInputField } from "../../../components";
import { PsignUpData } from "../../../assets/lib/plogin";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { CircularLoader } from "../../../components/widgets/CircularLoader";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  contentWrapper: {
    position: "relative",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
  },
  logo: {
    width: "160px",
    
  },
  formCard: {
    backgroundColor: "rgba(255, 255, 255)", // ✅ Transparent background
    backdropFilter: "blur(10px)",                // ✅ Frosted glass effect
    borderRadius: "12px",
    padding: "40px 30px",
    maxWidth: "400px",
    width: "100%",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    marginTop:"-190px"
  },
  heading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "5px",
    marginLeft:"0px",
    fontFamily: "Inter",

  },
  subheading: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "25px",
    marginLeft:"0px",
    fontFamily: "Inter",

  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginBottom: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.2)", // ✅ Transparent background

  },
  button: {
    backgroundColor: "#00C853",
    color: "#fff",
    width: "100%",
    padding: "10px",
    fontWeight: 600,
    borderRadius: "8px",
    marginTop: "10px",
  },
  footer: {
    fontSize: "14px",
    marginTop: "20px",
    textAlign: "center",
    color: "#888",
  },
  loginLink: {
    color: "#000",
    fontWeight: 600,
    cursor: "pointer",
    marginLeft: "5px",
  },
  transparentInput: {
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      border: '1px solid rgba(255, 255, 255, 0.4)', // optional
      color: '#fff', // for visibility
    },
    '& input': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.4)', // optional
    },
  },
}));

const Layout = (props) => {
  const {
    submitLoading,
    signUpState,
    errorFields,
    getSignUpInput,
    handleSubmitSignUp,
    handleOtpSendClick,
    otp,
    isInvalidOtp,
    phoneNoNot10Digit,
    passCodeNot4Digit,
    existingUser,
  } = props;

  const classes = useStyles();
  const navigate = useNavigate();

return (
  <div className={classes.wrapper}>
    <div style={{ width: "100vw", padding: "10px" }}>
      <img src={logo} alt="PickaaGo Logo" className={classes.logo} />
    </div>

    {submitLoading && <CircularLoader isPoistionAbsolute zIndex={3} />}

    <div className={classes.contentWrapper}>
      <div className={classes.formCard}>
        <div className={classes.heading} style={{ color: "#880E4F", fontSize: "18px" }}>
          <strong>Redefining the way you receive packages.</strong>
        </div>
        <div className={classes.subheading} style={{ fontWeight: 500 }}>
           Set up your PickaaGo account
        </div>

        <div className={classes.inputContainer}>
          <SingleInputField
            content={PsignUpData.userName}
            value={signUpState.userName}
            getInputData={getSignUpInput}
            errorFields={errorFields}
            className={classes.transparentInput}
          />
          <SingleInputField
            content={PsignUpData.phoneNumber}
            value={signUpState.phoneNumber}
            getInputData={getSignUpInput}
            errorFields={errorFields}
            isEditable={!otp}
            className={classes.transparentInput}
          />
          <SingleInputField
            content={PsignUpData.passCode}
            value={signUpState.passCode}
            getInputData={getSignUpInput}
            errorFields={errorFields}
            isEditable={!otp}
            className={classes.transparentInput}
          />
          {otp && (
            <SingleInputField
              content={PsignUpData.otp}
              value={signUpState.otp}
              getInputData={getSignUpInput}
              errorFields={errorFields}
              className={classes.transparentInput}
            />
          )}
        </div>

        {phoneNoNot10Digit && <p style={{ color: "red" }}>Phone number must be 10 digits.</p>}
        {existingUser && <p style={{ color: "red" }}>Phone number already registered.</p>}
        {passCodeNot4Digit && <p style={{ color: "red" }}>PIN must be 4 digits.</p>}
        {isInvalidOtp && (
          <p style={{ color: "red" }}>
            Invalid OTP!{" "}
            <span
              onClick={handleOtpSendClick}
              style={{ cursor: "pointer", color: "#880E4F", fontWeight: "bold" }}
            >
              Resend
            </span>
          </p>
        )}

        <Button
          variant="contained"
          style={{
            backgroundColor: "#880E4F",
            color: "#fff",
            width: "40%",
            padding: "10px",
            fontWeight: 600,
            borderRadius: "8px",
            marginLeft:"120px"
          }}
          onClick={otp ? handleSubmitSignUp : handleOtpSendClick}
        >
          {otp ? "Submit" : "Continue"}
        </Button>

        <div className={classes.footer}>
          Already have an account?
          <span className={classes.loginLink} onClick={() => navigate(routes.PUSER_LOGIN)}>
            &nbsp;Login
          </span>
        </div>
      </div>
    </div>
  </div>
);

};

export default Layout;
